/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getEventPowerPointsBySeasonEvent = function (seasonId,eventId) 
{
    const endpoint = `/${seasonId}/${eventId}/eventPowerPointsBySeasonEvent`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
}


// WEBPACK FOOTER //
// ./src/components/pages/api/getEventPowerPointsBySeasonEvent.js